/*
 * Copyright (c) University of Technology Sydney. All rights reserved.
 * See LICENSE file in the project root for full license information.
 *
 * Project Name: wpt-frontend.
 * Author: Michael Diponio
 * Created: 02/05/2022
 */

import * as React from 'react';
import { LabelCell, Row, ValueCell } from '@/wpt-lib/pdf/common/Table';
import { useLabel } from '@/wpt-lib/pdf/useData';

interface InternalCollaborator {
    internalCollaboratorName?: string;
    internalCollaboratorOrganisation?: string;
}

interface ExternalCollaborator {
    externalCollaboratorName?: string;
    externalCollaboratorOrganisation?: string;
}

const Collaborators = ({
    teachingEducational,
    collaborating,
    internalCollaborating = [],
    externalCollaborating = [],
    researchCollaborationType,
}: Partial<{
    teachingEducational: string;
    collaborating: string;
    internalCollaborating: InternalCollaborator[];
    externalCollaborating: ExternalCollaborator[];
    researchCollaborationType: string;
}>) => (
    <>
        <Row>
            <ValueCell
                single
                label={
                    teachingEducational === 'delivery'
                        ? 'Was this subject taught with another teacher?'
                        : 'Activity collaborators'
                }
                value={collaborating && useLabel('collaborating', collaborating)}
            />
        </Row>
        {researchCollaborationType && (
            <Row>
                <ValueCell
                    single
                    label="Collaboration Type"
                    value={useLabel('researchCollaborationType', researchCollaborationType)}
                />
            </Row>
        )}
        {[...internalCollaborating, ...externalCollaborating].map(
            (collab: InternalCollaborator & ExternalCollaborator, i) => (
                <Row key={i} widths={[7, 43, 50]}>
                    <LabelCell label={collab?.externalCollaboratorName ? 'External' : 'Internal'} />
                    <ValueCell
                        single
                        label="Name"
                        value={collab?.internalCollaboratorName ?? collab?.externalCollaboratorName}
                    />
                    <ValueCell
                        single
                        label={collab?.externalCollaboratorName ? 'School/Institute/Organisation' : 'Organisation'}
                        value={collab?.internalCollaboratorOrganisation ?? collab?.externalCollaboratorOrganisation}
                    />
                </Row>
            ),
        )}
    </>
);

export default Collaborators;
